import { Fragment } from 'react';
import { css } from 'twin.macro';
import { VscLoading } from 'react-icons/vsc';
import { FormPackageTable, ScrollContainer } from '../../TeamSettingFormPackage';
import FormSvg from '../../../../../../assets/forms.svg';
import Pagination from '../../../../../Admin/Pagination';
import BulkSubmissionModal from './BulkSubmissionModal';
import UserFormDataRow from './UserFormDataRow';

const Table = ({
    managerView,
    formId,
    teamId,
    teamIds,
    channel,
    member,
    form,
    filteredForms,
    totalForms,
    scrollRef,
    onScroll,
    formCounter,
    setForm,
    currentPage,
    startDate,
    endDate,
    loadingFiles,
    onPageChanged,
    updateTagsInSubmittedForms,
    hideFormPreview,
    handleUpdateUserFormDataPreview,
}) => {
    return (
        <Fragment>
            {loadingFiles ? (
                <h4 className="text-center">
                    <VscLoading className="spin" fontSize="42" />
                </h4>
            ) : filteredForms.length ? (
                <div className="custom-card">
                    <ScrollContainer ref={scrollRef} onScroll={onScroll}>
                        <FormPackageTable className="w-100">
                            <thead>
                                <tr>
                                    <th>S.N</th>
                                    <th>Submitted by</th>
                                    <th>Form name</th>
                                    {/* <th>Created At</th> */}
                                    {managerView && <th>Team</th>}
                                    <th>Channel</th>
                                    <th>Status</th>
                                    <th>Submitted At</th>
                                </tr>
                            </thead>
                            <tbody>
                                <Fragment>
                                    {filteredForms.length > 0 &&
                                        filteredForms.map((form, i) => (
                                            <UserFormDataRow
                                                key={form._id}
                                                currentPage={currentPage}
                                                formCounter={formCounter}
                                                i={i}
                                                form={form}
                                                setForm={setForm}
                                                managerView={managerView}
                                            />
                                        ))}
                                </Fragment>
                            </tbody>
                        </FormPackageTable>
                    </ScrollContainer>
                </div>
            ) : (
                <div
                    css={css`
                        background-color: white;
                        box-shadow: rgb(99 99 99 / 20%) 0px 2px 8px 0px;
                        border-radius: 5px;
                        padding: 15px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        flex-direction: column;
                    `}
                >
                    <img
                        src={FormSvg}
                        alt={'no documents found'}
                        css={css`
                            width: 350px;
                            margin: 1rem 0;
                        `}
                    />
                    <h2 className="text-center">No matching results</h2>
                    <div className="text-center">Try another search, or use search filters to find the document.</div>
                </div>
            )}
            <BulkSubmissionModal
                form={form}
                teamId={teamId}
                teamIds={teamIds}
                channel={channel}
                member={member}
                startDate={startDate}
                endDate={endDate}
                hideFormPreview={hideFormPreview}
            />
            <div className="p-4">
                <Pagination
                    totalRecords={totalForms}
                    key={totalForms}
                    pageLimit={10}
                    pageNeighbours={1}
                    onPageChanged={onPageChanged}
                />
            </div>
        </Fragment>
    );
};

export default Table;
